import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../theme';
import { borderRadius } from '../../styles/mixins';

export const useConfigurableCardStyles = createStyles(({ token }) => ({
  configurableCard: {
    '.ConfigurableCard-Header': {
      height: '24px',
      backgroundColor: ThemeColors.COLOR_GREY_BLUISH,
      padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
      boxShadow: `-6px -6px 15px ${token.colorWhite}`,
      ...borderRadius({ side: 'top' }),
      fontWeight: 500,
      color: token.colorWhite,
      'h4.ant-typography': {
        fontSize: token.fontSize,
        color: token.colorWhite,
        marginBottom: 0,
      },
      '.LinksRow': {
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      },
    },
    '.ConfigurableCard-Body': {
      position: 'relative',
      backgroundColor: ThemeColors.COLOR_WHITE3,
      borderLeft: `1px solid ${ThemeColors.COLOR_GREY9}`,
      borderRight: `1px solid ${ThemeColors.COLOR_GREY9}`,
      boxShadow: `1px -1px 15px ${ThemeColors.COLOR_GREY_BLUISH_DISABLED}`,
      flexWrap: 'initial',
      '&.no-footer': {
        ...borderRadius({ side: 'bottom' }),
        borderBottom: `1px solid ${ThemeColors.COLOR_GREY9}`,
      },
    },
  },
  configurableCardFooter: {
    backgroundColor: ThemeColors.COLOR_GREY9_9,
    border: `1px solid ${token.colorWhite}`,
    borderTopWidth: 0,
    ...borderRadius({ side: 'bottom' }),
    boxShadow: `0px 2px 6px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH, 0.35)}, inset 0 -1px 8px ${ThemeColors.COLOR_GREY9_7}`,
    margin: `0 ${ThemeSpaces.SPACE_XS}px 0 ${ThemeSpaces.SPACE_XS}px`,
  },
}));

export const useCardElementsStyles = createStyles(({ token }) => ({
  simpleCard: {
    '.SimpleCard-Header': {
      position: 'relative',
      height: '32px',
      textAlign: 'center',
      borderBottom: `1px solid ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH, 0.35)}`,
      'h4.ant-typography': {
        fontFamily: ThemeFont.FONT_CONDENSED,
        fontSize: token.fontSizeLG,
        fontWeight: 'bold',
        marginBottom: 0,
      },
    },
    '&.collapsible .SimpleCard-Header': {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      textAlign: 'initial',
      padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
    },
    '.SimpleCard-Body': {
      backgroundColor: token.colorWhite,
      ...borderRadius({ side: 'bottom' }),
      boxShadow: `1px 1px 6px ${ThemeColors.COLOR_GREY8_1}`,
      color: ThemeColors.COLOR_GREY3,
    },
    '&.SimpleCardTheme-ROUND_BORDERED': {
      borderRadius: token.borderRadiusSM,
      boxShadow: `0 0 6px ${ThemeColors.COLOR_GREY8_1}`,
      backgroundColor: token.colorWhite,
      '.SimpleCard-Header': {
        backgroundColor: ThemeColors.COLOR_WHITE7,
        border: `1px solid ${token.colorWhite}`,
        boxShadow: `0 4px 10px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH7_2, 0.25)}`,
        ...borderRadius({ side: 'top' }),
        'h4.ant-typography': {
          lineHeight: '30px',
          color: ThemeColors.COLOR_GREY_BLUISH5,
          letterSpacing: '-0.18px',
        },
      },
      '.SimpleCard-Body': {
        fontSize: token.fontSizeSM,
        color: ThemeColors.COLOR_GREY3,
        boxShadow: 'none',
      },
    },
    '&.SimpleCardTheme-FLAT': {
      '.SimpleCard-Header': {
        backgroundColor: ThemeColors.COLOR_GREY10,
        borderTop: `2px solid ${token.colorWhite}`,
        'h4.ant-typography': {
          lineHeight: '32px',
          color: ThemeColors.COLOR_GREY3,
          textTransform: 'uppercase',
          fontSize: token.fontSize,
        },
      },
      '.SimpleCard-Body': {
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
        lineHeight: `${token.fontSizeLG}px`,
        color: ThemeColors.COLOR_GREY3,
      },
    },
  },
  simpleCardSubtitle: {
    position: 'relative',
    height: '24px',
    backgroundColor: ThemeColors.COLOR_WHITE3,
    borderTop: `1px solid ${ThemeColors.COLOR_GREY8_1}`,
    borderBottom: `1px solid ${token.colorWhite}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    fontWeight: 'bold',
    '&::before, &::after': {
      content: "''",
      position: 'absolute',
      left: 0,
      right: 0,
    },
    '&::before': {
      top: 0,
      borderTop: `1px solid ${token.colorWhite}`,
    },
    '&::after': {
      bottom: 0,
      borderBottom: `1px solid ${ThemeColors.COLOR_GREY8_1}`,
    },
  },
}));
